import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import TurnstileWidget from '../components/TurnstileWidget'

export default function ResetPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [error, setError] = useState(null)
  const [turnstileToken, setTurnstileToken] = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    if (!turnstileToken) {
      setError('Completá la verificación anti-bot antes de continuar')
      return
    }
    setLoading(true)
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim().toLowerCase(), {
      redirectTo: `${window.location.origin}/set-password`,
      captchaToken: turnstileToken,
    })
    setLoading(false)
    if (error) {
      setError(error.message)
      return
    }
    // Por seguridad: siempre decimos "te mandamos el mail" aunque el email no exista en la base
    setEnviado(true)
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="brand">Lim<em>pack</em></div>
        <div className="tag">Limpieza, resuelta cada mes.</div>

        <h1>¿Olvidaste tu contraseña?</h1>

        {enviado ? (
          <div style={{ background: '#ECFDF5', border: '1.5px solid #10B981', borderRadius: 10, padding: 16, marginTop: 16 }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📧</div>
            <p style={{ margin: 0, color: '#065F46', fontWeight: 600 }}>
              Si <strong>{email}</strong> está registrado en Limpack, te llegó un email con el link para restablecer tu contraseña.
            </p>
            <p style={{ margin: '8px 0 0', color: '#065F46', fontSize: 13 }}>
              Revisá tu bandeja de entrada (y la carpeta de spam, por las dudas).
            </p>
          </div>
        ) : (
          <>
            <p className="lead">Te mandamos un email con un link para crear una contraseña nueva.</p>
            <form onSubmit={handleSubmit}>
              <label>
                <b>Email registrado</b>
                <input
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                />
              </label>
              <TurnstileWidget action="reset-password" onToken={setTurnstileToken} />
              <button type="submit" disabled={loading || !turnstileToken}>
                {loading ? 'Enviando…' : 'Enviar link de reset'}
              </button>
              {error && <div className="err">{error}</div>}
            </form>
          </>
        )}

        <div style={{ textAlign: 'center', marginTop: 18, paddingTop: 16, borderTop: '1px dashed var(--line)' }}>
          <Link to="/login" style={{ color: 'var(--muted)', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>
            ← Volver al login
          </Link>
        </div>
      </div>
    </div>
  )
}
